import { CommonFunctions } from '../static/common-functions';
import { Subscription } from 'rxjs';
import { BasePage } from './BasePage';
import { StatusHistoryBus } from './StatusHistoryBus';
//import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY } from '@angular/cdk/overlay/typings/overlay-directives';
import { EmployeeService } from '../services/employee.service';

export class EmployeePage extends BasePage<EmployeeService>
{
    svc_data: EmployeeService;
    constructor(svc_data: EmployeeService, data: EmployeePage = null) {
        super();
        this.svc_data = svc_data;
        if (data !== null) {
            //      this.dispatchId = data.dispatchId;
        }
    }

    clear() {
        this.unsubscribe();
        this.id = null;
        this.statusHistory = null;
    }
    unsubscribe() {
        CommonFunctions.unsubscribe(this.subs_statusHistory);
    }

    subs_statusHistory: Subscription;

    getStatusHistory(id: any) {
        //CommonFunctions.unsubscribe(this.subs_statusHistory);
        //this.subs_statusHistory = this.svc_data.getStatusHistory(id).subscribe(data => {
        //    this.statusHistory = data;
        //});
    }
    id: any;
    statusHistory: StatusHistoryBus[];
    get hasStatusHistory(): boolean {
        return CommonFunctions.hasValue(this.statusHistory);
    }
}
